<template>
    <div>
        <div class="menu">해와달 인테리어 관리자 페이지</div>
        <div class="admin-nav" v-if="$store.getters.isAdminAuthenticated">
            <router-link :to="{name:'adminApartments'}">아파트 관리</router-link>
            <router-link :to="{name:'adminHome'}">메인홈 사진</router-link>
            <router-link :to="{name:'adminSettings'}">계정 설정</router-link>
            <router-link :to="{name:'adminCosts'}">비용</router-link>
            <button type="button" class="logout-btn" @click="logout">로그아웃</button>
        </div>
        <transition name="fade" mode="out-in">
            <router-view class="view"/>
        </transition>
    </div>
</template>

<script>
import {Vue, Component} from 'vue-property-decorator'
import { adminApi } from '@/store'

@Component
export default class Wrapper extends Vue {
    async beforeMount () {
        const param = this.getParam()
        if (param.path) {
            await this.$router.push({name: param.path, query: param}).catch(() => {})
        }
    }

    getParam () {
        const search = location.search.substring(1);
        if (search.length === 0) return {}
        return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')
    }

    logout () {
        this.$store.dispatch('adminLogout')
        this.$router.push({ name: 'admin' })
    }
}
</script>

<style scoped lang="scss">
@import 'src/assets/style/common';
@import 'src/assets/style/media-query';
.menu {
    text-align: center;
    font-size: 34px;
    margin: 20px 0;
}
.admin-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 8px 0;
    border-bottom: 1px solid $transparent-dark-theme;
    margin-bottom: 12px;

    a {
        color: $dark-theme;
        text-decoration: none;
        font-size: 14px;
        &.router-link-active {
            font-weight: bold;
            border-bottom: 2px solid $dark-theme;
        }
    }

    .logout-btn {
        padding: 3px 10px;
        border: 1px solid $transparent-dark-theme;
        background: transparent;
        color: $dark-theme;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.2s;
        &:hover:not(:disabled) {
            background: $bright-theme-100;
        }
        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
            background: #eee;
        }
    }
}
.view {
    margin: auto;
    width: 80%;
    height: calc(100vh - 76px);
    color: $dark-theme;
}
</style>
<style lang="scss">
@import 'src/assets/style/common';
@import 'src/assets/style/media-query';
.button {
    padding: 3px;
    border: 1px solid $transparent-dark-theme;
}
</style>